var addDOMEventListener = require('add-dom-event-listener');

module.exports = addDOMEventListener['default'] || addDOMEventListener;



//////////////////
// WEBPACK FOOTER
// ./~/rc-util/lib/Dom/addEventListener.js
// module id = 2156
// module chunks = 0